import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentPreview = ({ template, formData, onEdit }) => {
  if (!template) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center p-6 md:p-8">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
          لم يتم اختيار قالب
        </h3>
        <p className="text-sm md:text-base text-muted-foreground max-w-md">
          اختر قالباً من القائمة الجانبية لعرض المعاينة وإنشاء المستند
        </p>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between p-4 md:p-6 border-b border-border bg-muted/30">
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="sm"
            iconName="Edit"
            iconSize={16}
            onClick={onEdit}
          >
            تعديل
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="ZoomIn"
            iconSize={16}
          >
            تكبير
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="ZoomOut"
            iconSize={16}
          >
            تصغير
          </Button>
        </div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          معاينة: {template?.name}
        </h3>
      </div>
      <div className="flex-1 overflow-auto p-4 md:p-6 bg-muted/10">
        <div className="max-w-4xl mx-auto bg-card shadow-warm-lg rounded-lg p-6 md:p-8 lg:p-12" dir="rtl">
          <div className="text-center mb-8 md:mb-12">
            <div className="w-24 h-24 md:w-32 md:h-32 mx-auto mb-4">
              <img
                src="/assets/images/2arddgoldlogotransembo-1768095394670.png"
                alt="ARDDjo Real Estate Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-base md:text-lg text-primary font-bold font-heading mb-4">
              ARDDjo REAL ESTATE
            </p>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
              {template?.name}
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              تاريخ الإصدار: {new Date()?.toLocaleDateString('ar-SA')}
            </p>
          </div>

          <div className="space-y-6 md:space-y-8">
            <div className="border-r-4 border-primary pr-4">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">
                معلومات العقار
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">اسم العقار</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.propertyName || '[اسم العقار]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">نوع العقار</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.propertyType || '[نوع العقار]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">تصنيف العقار</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.realEstateType || '[تجاري/سكني]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">الموقع</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.location || '[الموقع]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">السعر</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.price || '[السعر]'} دينار أردني
                  </p>
                </div>
              </div>
            </div>

            <div className="border-r-4 border-secondary pr-4">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">
                معلومات المالك
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">اسم المالك</p>
                  <p className="text-base font-medium text-foreground">
                    {formData?.ownerName || '[اسم المالك]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">رقم الهاتف</p>
                  <p className="text-base font-medium text-foreground font-data">
                    {formData?.ownerPhone || '[رقم الهاتف]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">البريد الإلكتروني</p>
                  <p className="text-base font-medium text-foreground font-data">
                    {formData?.ownerEmail || '[البريد الإلكتروني]'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">رقم الهوية</p>
                  <p className="text-base font-medium text-foreground font-data">
                    {formData?.ownerId || '[رقم الهوية]'}
                  </p>
                </div>
              </div>
            </div>

            <div className="border-r-4 border-accent pr-4">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">
                تفاصيل إضافية
              </h2>
              <p className="text-sm md:text-base text-foreground leading-relaxed">
                {formData?.additionalDetails || '[تفاصيل إضافية عن العقار والشروط والأحكام]'}
              </p>
            </div>

            {formData?.remarks && (
              <div className="border-r-4 border-secondary pr-4">
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">
                  ملاحظات
                </h2>
                <p className="text-sm md:text-base text-foreground leading-relaxed">
                  {formData?.remarks}
                </p>
              </div>
            )}
          </div>

          <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-border">
            {/* Company Footer Section */}
            <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg p-4 md:p-6 mb-6">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16">
                    <img
                      src="/assets/images/2arddgoldlogotransembo-1768095394670.png"
                      alt="ARDDjo Logo"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="text-right">
                    <p className="text-base font-bold text-primary font-heading">ARDDjo Real Estate</p>
                    <p className="text-sm text-muted-foreground">عقارات ARDDjo</p>
                  </div>
                </div>
                <div className="text-center md:text-left space-y-1">
                  <p className="text-sm text-foreground flex items-center gap-2 justify-center md:justify-start">
                    <Icon name="Phone" size={14} color="var(--color-primary)" />
                    <span className="font-data">+962 6 XXX XXXX</span>
                  </p>
                  <p className="text-sm text-foreground flex items-center gap-2 justify-center md:justify-start">
                    <Icon name="Mail" size={14} color="var(--color-primary)" />
                    <span className="font-data">info@arddjo.com</span>
                  </p>
                  <p className="text-sm text-foreground flex items-center gap-2 justify-center md:justify-start">
                    <Icon name="Globe" size={14} color="var(--color-primary)" />
                    <span className="font-data">www.arddjo.com</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="text-center md:text-right">
                <p className="text-sm text-muted-foreground mb-1">التوقيع</p>
                <div className="w-32 h-16 border-b-2 border-foreground"></div>
              </div>
              <div className="text-center">
                <p className="text-sm text-muted-foreground">
                  تم إنشاء هذا المستند بواسطة نظام ARDDjo لإدارة العقارات
                </p>
                <p className="text-xs text-muted-foreground font-data">
                  {new Date()?.toLocaleString('ar-SA')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview;